import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { textFormatter } from "components/Common/formatter";
import { Collapse } from "antd";
import { retrieveTripAssets } from "utils/api";
import NGITable from "components/Common/NGITable";
import { assetsColumns } from "pages/stock-management/trips/tripDetails/constants";

const useStyles = makeStyles({
  assetItem: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#f5f5f5",
    borderRadius: 50,
    padding: "9px 20px",
    height: 50,
  },
  changed: {
    backgroundColor: "#ecfaf0",

    "&> .ant-collapse-header": {
      backgroundColor: "#ecfaf0",
      borderRadius: "30px!important",
    },
    "&> .ant-collapse-content": {
      backgroundColor: "#ecfaf0!important",
    },
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    width: 32,
    borderRadius: 50,
    marginRight: 20,
    background: "rgba(255, 255, 255, 1)",
  },
  subtitle: {
    marginRight: 10,
    color: "grey",
  },
  rightContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "50%",
    marginRight: 10,
  },
  outbound: {
    marginLeft: 3,
  },
  inbound: {
    marginRight: 3,
  },
  displayFlex: {
    display: "flex",
  },
  link: {
    fontWeight: 600,
    textDecoration: "underline",
  },
  collapse: {
    marginBottom: 10,
    border: "none",
    borderRadius: "30px",
    backgroundColor: "#f5f5f5",
    "&> .ant-collapse-item:last-child > .ant-collapse-header": {
      borderRadius: "0px 0px 30px 30px",
    },
    "&> .ant-collapse-item": {
      borderBottom: "none",
    },
  },
  collapsePanel: {
    borderRadius: "30px!important",

    "&> .ant-collapse-header": {
      padding: "0 !important",
      borderBottom: "none",
    },
    "&> .ant-collapse-content": {
      backgroundColor: "#f5f5f5",
      borderRadius: "0px 0px 30px 30px !important",
    },
  },
  description: {
    display: "flex",
    justifyContent: "center",
  },
  viewAll: {
    height: 49,
    display: "flex",
    alignItems: "center",
    marginRight: 13,
    textDecoration: "underline",
  },
  extraContainer: {
    display: "flex",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    width: 32,
    borderRadius: 50,
    background: "rgba(255, 255, 255, 1)",

    "&:hover": {
      cursor: "pointer",
      opacity: 0.6,
    },
  },
});

const { Panel } = Collapse;

const LostAssetItem = ({ asset, tripNumber }) => {
  const classes = useStyles();
  const { group, condition } = asset;
  const [loadingState, setLoadingState] = useState({
    lost: false,
  });

  const [lostAssets, setLostAssets] = useState([]);

  const loadAssets = useCallback(list => {
    if (list.length) {
      getLostAssets();
    }
  }, []);

  const getLostAssets = useCallback((filterOptions = {}) => {
    setLoadingState(prevState => ({ ...prevState, lost: true }));
    retrieveTripAssets(tripNumber, {
      listType: "lost",
      assetsGroup: group,
      assetsCondition: condition,
      ...filterOptions,
    }).then(res => {
      setLoadingState(prevState => ({ ...prevState, lost: false }));
      setLostAssets(res?.data || []);
    });
  }, []);

  return (
    <>
      <Collapse onChange={loadAssets} className={classes.collapse} collapsible expandIconPosition={"end"}>
        <Panel
          key={"panel"}
          className={classes.collapsePanel}
          extra={
            <div className={classes.extraContainer}>
              <div className={classes.viewAll}>View all assets</div>
            </div>
          }
          showArrow={false}
          header={
            <div className={classes.assetItem}>
              <div className={classes.iconContainer}>
                <div>{group}</div>
              </div>
              <div className={classes.rightContainer}>
                <div className={classes.displayFlex}>
                  <span className={classes.subtitle}>Condition</span>
                  <b>{textFormatter(condition)}</b>
                </div>
              </div>
            </div>
          }
          style={{ padding: 0, margin: 0 }}
        >
          <h6>Lost assets:</h6>
          <NGITable
            isLoading={loadingState.lost}
            columns={assetsColumns()}
            data={lostAssets}
            updateList={getLostAssets}
          />
        </Panel>
      </Collapse>
    </>
  );
};

export default LostAssetItem;
